import { Screen } from "../components/Screen";
import { CSSProperties, useEffect, useState } from "react";
import { Footer } from "../components/Footer";
import { Colors } from "../constants/colors";
import { Font } from "../constants/fonts";
import { Button } from "../components/Button";
import Icons from "../constants/icons";
import { sendEmail } from "../services/EmailSender";
import { showAlert } from "../services/SweetAlert";
import { Config } from "../config/config";

export default function Contato() {
    const [isMobile, setIsMobile] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (isMobile) {
        return (
            <Screen>
                <div style={mobileStyles.container}>
                    <div style={mobileStyles.title}>
                        Fale com a equipe ClikMob
                    </div>
                    <div style={mobileStyles.legend}>
                        Quer saber mais sobre o ClikMob? Entre em contato com a nossa equipe, envie suas dúvidas ou acompanhe nossas redes sociais.
                    </div>
                </div>
                
                <div style={mobileStyles.imageContainer}>
                    <img src="/undraw_security_0ubl 1.svg" alt="ClickMob contato" style={mobileStyles.logo}/>
                </div>
                
                <div style={mobileStyles.formContainer}>
                    <label style={mobileStyles.label}>Nome</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={mobileStyles.input}
                        placeholder="Digite seu nome"
                    />
                    
                    <label style={mobileStyles.label}>Mensagem</label>
                    <textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        style={mobileStyles.textarea}
                        placeholder="Digite sua mensagem..."
                        rows={5}
                    />
                    
                    <div style={mobileStyles.buttonContainer}>
                        <Button
                            text="Enviar mensagem"
                            onClick={() => {
                                try{
                                    const response: any = sendEmail({
                                        name: name,
                                        email: email,
                                        message: message
                                    });

                                    if(!response || response.success === false){
                                        showAlert('error', 'Erro', response?.message || 'Não foi possível enviar sua mensagem. Tente novamente mais tarde.');
                                        return;
                                    }

                                    // showAlert('success', 'Mensagem enviada', response?.message || 'Sua mensagem foi enviada com sucesso. Em breve entraremos em contato!');
                                    // setName("");
                                    // setEmail("");
                                    // setMessage("");
                                }catch(error){
                                    showAlert('error', 'Erro', 'Não foi possível enviar sua mensagem. Tente novamente mais tarde.');
                                    return;
                                }
                            }}
                            width="100%"
                        />
                    </div>
                </div>
                
                <div style={mobileStyles.iconContainer}>
                    <div style={mobileStyles.iconGrid}>
                        <a href={Config.whatsappLink} target="_blank" rel="noopener noreferrer" style={mobileStyles.iconLink}>
                            <div style={mobileStyles.iconItem}>
                                <Icons
                                    color={Colors.primary}
                                    name="whatsapp"
                                    size={35}
                                />
                                <div style={mobileStyles.iconLabel}>WhatsApp</div>
                            </div>
                        </a>
                        
                        {/* <a href={Config.linkedinLink} target="_blank" rel="noopener noreferrer" style={mobileStyles.iconLink}>
                            <div style={mobileStyles.iconItem}>
                                <Icons
                                    color={Colors.primary}
                                    name="linkedin"
                                    size={35}
                                />
                                <div style={mobileStyles.iconLabel}>Linkedin</div>
                            </div>
                        </a> */}
                        
                        {/* <a href={Config.instagramLink} target="_blank" rel="noopener noreferrer" style={mobileStyles.iconLink}>
                            <div style={mobileStyles.iconItem}>
                                <Icons
                                    color={Colors.primary}
                                    name="instagram"
                                    size={35}
                                />
                                <div style={mobileStyles.iconLabel}>Instagram</div>
                            </div>
                        </a> */}
                        
                        <a href={Config.emailLink} target="_blank" rel="noopener noreferrer" style={mobileStyles.iconLink}>
                            <div style={mobileStyles.iconItem}>
                                <Icons
                                    color={Colors.primary}
                                    name="email"
                                    size={35}
                                />
                                <div style={mobileStyles.iconLabel}>E-mail</div>
                            </div>
                        </a>
                    </div>
                </div>
                
                <div style={mobileStyles.subTitle}>
                    Estamos construindo um novo caminho na mobilidade urbana.<br/>
                    Junte-se ao ClikMob e faça parte dessa transformação.
                </div>
                
                <Footer
                    color={Colors.white}
                    backgroundColor={Colors.primary}
                    image="/LOGO%20TM%203.svg"
                />
            </Screen>
        );
    }

    // Return original (desktop) intacto
    return (
        <Screen>
            <div style={styles.container}>
                <div style={styles.title}>
                    Fale com a equipe ClikMob
                </div>
                <div style={styles.legend}>
                    Quer saber mais sobre o ClikMob?  Entre em contato com a nossa equipe, envie suas dúvidas ou acompanhe nossas redes sociais.
                </div>
            </div>
            <div style={styles.formContainer}>
                <div style={styles.fomrSubContainer}>
                    <label style={styles.label}>Nome</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        style={styles.input}
                    />
                    {/* <label style={styles.label}>E-mail</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={styles.input}
                        color={Colors.secondaryLight}
                    /> */}
                    <label style={styles.label}>Mensagem</label>
                    <textarea
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        style={{ ...styles.input, height: 150 }}
                    />
                </div>
                <div style={styles.formSubContainer2}>
                    <img src="/undraw_security_0ubl 1.svg" alt="ClickMob logo" style={styles.logo}/>
                </div>
            </div>
            <div style={styles.buttonContainer}>
                <Button
                    text="Enviar mensagem"
                    onClick={() => {
                        try{
                            const response: any = sendEmail({
                                name: name,
                                email: email,
                                message: message
                            });

                            if(!response || response.success === false){
                                showAlert('error', 'Erro', response?.message || 'Não foi possível enviar sua mensagem. Tente novamente mais tarde.');
                                return;
                            }

                            // showAlert('success', 'Mensagem enviada', response?.message || 'Sua mensagem foi enviada com sucesso. Em breve entraremos em contato!');
                            // setName("");
                            // setEmail("");
                            // setMessage("");
                        }catch(error){
                            showAlert('error', 'Erro', 'Não foi possível enviar sua mensagem. Tente novamente mais tarde.');
                            return;
                        }
                    }}
                    width={460}
                />
            </div>
            <div style={styles.iconContainer}>
                <a href={Config.whatsappLink} target="_blank" rel="noopener noreferrer" style={styles.iconLink}>
                    <div style={styles.iconText}>
                        <Icons
                            color={Colors.primary}
                            name="whatsapp"
                            size={40}
                        />
                        <b>WhatsApp</b>
                    </div>
                </a>
                {/* <a href={Config.linkedinLink} target="_blank" rel="noopener noreferrer" style={styles.iconLink}>
                    <div style={styles.iconText}>
                        <Icons
                            color={Colors.primary}
                            name="linkedin"
                            size={40}
                        />
                        <b>Linkedin</b>
                    </div>
                </a> */}
                {/* <a href={Config.instagramLink} target="_blank" rel="noopener noreferrer" style={styles.iconLink}>
                    <div style={styles.iconText}>
                        <Icons
                            color={Colors.primary}
                            name="instagram"
                            size={40}
                        />
                        <b>Instagram</b>
                    </div>
                </a> */}
                <a href={Config.emailLink} target="_blank" rel="noopener noreferrer" style={styles.iconLink}>
                    <div style={styles.iconText}>
                        <Icons
                            color={Colors.primary}
                            name="email"
                            size={40}
                        />
                        <b>E-mail</b>
                    </div>
                </a>
            </div>
            <div style={styles.subTitle}>
                Estamos construindo um novo caminho na mobilidade urbana.<br></br>
                Junte-se ao ClikMob e faça parte dessa transformação.
            </div>
             <Footer
                color={Colors.white}
                backgroundColor={Colors.primary}
                image="/LOGO%20TM%203.svg"
            />
        </Screen>
    );
}

// Estilos desktop originais (mantidos intactos)
const styles:  { [key: string]: CSSProperties } = {
    container: {
        width: '100%',
        backgroundColor: Colors.white
    },
    title: {
        fontSize: Font.title2.fontSize-10,
        fontWeight: Font.title2.fontWeight,
        textAlign: 'center',
        paddingTop: 60,
        paddingBottom: 35,
        color: Colors.primary
    },
     subTitle: {
        fontSize: Font.title2.fontSize-10,
        fontWeight: Font.title2.fontWeight,
        textAlign: 'center',
        padding: 50,
        color: Colors.primary
    },
    legend: {
        fontSize: Font.menu.fontSize,
        textAlign: 'center',
        marginBottom: 40,
        color: Colors.primary
    },
    formContainer: {
        backgroundColor: Colors.gray,
        padding: '30px 150px',
        display: 'flex',
        flexDirection: 'row',
        gap: 70,
        justifyContent: 'center',
        alignItems: 'center'
    },
    fomrSubContainer: {
        width: '50%',
        justifyContent: 'center',
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    formSubContainer2: {
        width: '50%'
    },
    formSubContainer3: {

    },
    label: {
        fontSize: Font.text.fontSize,
        color: Colors.secondaryDark,
        textAlign: 'left'
    },
    input: {
        padding: 10,
        backgroundColor: Colors.white,
        borderRadius: 15,
        border: `1px solid ${Colors.primary}`,
        width: '100%',
        fontSize: Font.text.fontSize,
        color: Colors.secondaryLight,
        marginBottom: 35
    },
    logo: {
        height: 515,
        borderRadius: 15
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: 40
    },
    iconContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 120,
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginTop: 50
    },
    iconText: {
        fontSize: Font.button.fontSize,
        color: Colors.primary,
        fontWeight: '500',
        marginLeft: 10,
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex'
    },
    iconLink: {
        textDecoration: 'none',
        color: 'inherit',
        display: 'inline-block',
        cursor: 'pointer'
    }
}

// Estilos mobile otimizados
const mobileStyles: { [key: string]: CSSProperties } = {
    container: {
        width: '100%',
        backgroundColor: Colors.white,
        padding: '30px 20px 20px 20px',
    },
    title: {
        fontSize: (Font.title2.fontSize - 10) * 0.85,
        fontWeight: Font.title2.fontWeight,
        textAlign: 'center',
        color: Colors.primary,
        marginBottom: 20,
        lineHeight: 1.3,
    },
    legend: {
        fontSize: Font.menu.fontSize * 0.95,
        textAlign: 'center',
        color: Colors.primary,
        lineHeight: 1.4,
        marginBottom: 30,
    },
    imageContainer: {
        backgroundColor: Colors.gray,
        padding: '30px 20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    logo: {
        width: '100%',
        maxWidth: 300,
        height: 'auto',
        borderRadius: 15,
    },
    formContainer: {
        backgroundColor: Colors.gray,
        padding: '30px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 15,
    },
    label: {
        fontSize: Font.text.fontSize * 0.95,
        color: Colors.secondaryDark,
        textAlign: 'left',
        fontWeight: '500',
    },
    input: {
        padding: '12px 15px',
        backgroundColor: Colors.white,
        borderRadius: 12,
        border: `1px solid ${Colors.primary}`,
        width: '100%',
        fontSize: Font.text.fontSize * 0.95,
        color: Colors.secondaryLight,
        marginBottom: 20,
        boxSizing: 'border-box',
    },
    textarea: {
        padding: '12px 15px',
        backgroundColor: Colors.white,
        borderRadius: 12,
        border: `1px solid ${Colors.primary}`,
        width: '100%',
        fontSize: Font.text.fontSize * 0.95,
        color: Colors.secondaryLight,
        marginBottom: 20,
        boxSizing: 'border-box',
        resize: 'vertical',
        minHeight: 120,
        fontFamily: 'inherit',
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
        marginBottom: 10,
    },
    iconContainer: {
        backgroundColor: Colors.white,
        padding: '30px 20px',
    },
    iconGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 25,
    },
    iconItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
        padding: '15px 10px',
        borderRadius: 12,
        backgroundColor: Colors.gray || '#f5f5f5',
        transition: 'transform 0.2s',
    },
    iconLabel: {
        fontSize: Font.button.fontSize * 0.9,
        color: Colors.primary,
        fontWeight: '500',
        textAlign: 'center',
    },
    iconLink: {
        textDecoration: 'none',
        color: 'inherit',
        display: 'block',
        cursor: 'pointer',
    },
    subTitle: {
        fontSize: (Font.title2.fontSize - 10) * 0.8,
        fontWeight: Font.title2.fontWeight,
        textAlign: 'center',
        padding: '30px 20px',
        color: Colors.primary,
        lineHeight: 1.4,
        backgroundColor: Colors.white,
    },
};